import React from 'react';
import "./styles.css";

export const AboutMeComponentV2 = () => (
	<React.Fragment>
        <div class="outer">
            <div class="img">
                <img src={process.env.PUBLIC_URL+ "/img/calvin-original-crop.jpg"} style={{width: "100%"}}/>
            </div>
            <div class="txt">
                <div className='aboutme'>ABOUT ME</div>
                    <div className='aboutmecontent'>
                    I am a third-year Computer Science Ph.D. Candidate 
                    in <a className='link' href='http://mislab.cs.nthu.edu.tw'>Multimedia Information System Lab</a> at <a className='link' href='https://nthu-en.site.nthu.edu.tw'>National 
                    Tsing Hua University</a>, advised 
                    by <a className='link' href='https://scholar.google.com/citations?user=clfmfbAAAAAJ&hl=en'>Prof. Min-Chun Hu</a>. 
                    Prior to this, I received a Bachelor's degree in Computer Science and a minor in 
                    Robotics from the <a className='link' href='https://hkust.edu.hk'>Hong Kong University of Science and Technology (HKUST)</a> and was 
                    privileged to work 
                    with <a className='link' href='https://seng.hkust.edu.hk/about/people/faculty/richard-hau-yue-so'>Prof. Richard So </a>on Smart Fever Screening System 
                    that is currently implemented 
                    in <a className='link' href='http://panoptic.ai'>panoptic.ai</a> startup. 
                    I am also honored to had worked in <a className='link' href="https://www.tsmc.com/english">TSMC</a>'s' Big Data and Analytics lab for an internship. 
                </div>
                <br/>
                <div className='moreInfo'>
                    <a style={{color: "white"}}href={process.env.PUBLIC_URL+ "/CV-Calvin.pdf"} target = "_blank">⬇️ Download my Curriculum Vitae</a>
                    <a 
                        onClick={()=>{
                            window.location.href="https://www.linkedin.com/in/calvin-ku-12-09/";
                        }}
                        style={{marginLeft: "30px"}}>
                        👋 Say Hello to me
                    </a>
                </div>
            </div>
        </div>
        
	</React.Fragment>
);